import React, { useContext, useMemo } from 'react';
import { Chip } from '@mui/material';
import CustomizerContext from '../../../../_helper/Customizer';

const BadgesComponent = () => {
  const {
    EligibilityTableShow,
    ApplicantTableShow,
    resetGenrateGeneralAvailability,
    allApplicantsData,
  } = useContext(CustomizerContext);

  const ANNOUNCEMENT_ID_Value = useMemo(() => {
    const { ANNOUNCEMENT_ID } = EligibilityTableShow;
    if (ANNOUNCEMENT_ID) return ANNOUNCEMENT_ID.trim();
    return '';
  }, [EligibilityTableShow]);

  // const AllElgIdsPayload = useMemo(() => {
  //   if (allApplicantsData && allApplicantsData.length > 0) {
  //     return allApplicantsData.map((item) => item?.eligibility_id.trim());
  //   }
  //   return [];
  // }, [allApplicantsData]);

  // const AllElgIdsPayloadString = useMemo(
  //   () =>
  //     AllElgIdsPayload.length > 0
  //       ? AllElgIdsPayload.length === 1
  //         ? AllElgIdsPayload[0]
  //         : AllElgIdsPayload.join(',')
  //       : '',
  //   [AllElgIdsPayload]
  // );

  return (
    <div style={{ display: 'flex', justifyContent: 'center', gap: '40px' }}>
      <Chip
        label={`Announcement ID: ${ANNOUNCEMENT_ID_Value} (${EligibilityTableShow?.POSITION?.trim()}-${EligibilityTableShow?.JOB_TITLE_SHORT?.trim()})`}
        color="primary"
        variant="outlined"
        style={{ fontSize: '16px', padding: '10px' }}
      />
      {/* {AllElgIdsPayloadString && ApplicantTableShow && (
        <Chip
          label={`Eligibility IDs: ${AllElgIdsPayloadString}`}
          color="primary"
          variant="outlined"
          style={{ fontSize: '16px', padding: '10px' }}
        />
      )} */}
    </div>
  );
};

export default BadgesComponent;
